import {compact, uniq} from 'lodash';
import {useEffect} from 'react';

/**
 * Invokes `handler` once the targets are attached and again whenever any of them
 * changes size. Nullish targets are skipped; memoize the array, since a fresh one
 * re-runs the handler.
 */
function useOnResize(targets: ReadonlyArray<Element | null | undefined>, handler: () => void) {
  useEffect(() => {
    const observed = uniq(compact(targets));
    if (observed.length === 0) {
      return undefined;
    }
    handler();
    const observer = new ResizeObserver(handler);
    observed.forEach((target) => observer.observe(target));

    return () => {
      observer.disconnect();
    };
  }, [targets, handler]);
}

export default useOnResize;
